import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import menuFinances from '../assets/images/menu-finances.svg';
import CommingSoon from '../components/CommingSoon';

function FinancesPage() {

    const { t, i18n } = useTranslation();

    const breadcrumbs = {
        icon: menuFinances,
        items: [
            {
                url: 'finances',
                title: t('myFinances')
            }
        ]
    };

    return(
        <Layout page="finances" breadcrumbs={breadcrumbs} component={<CommingSoon />} />
    );

}

export default FinancesPage;